import React from 'react'
import { SVGProps } from './types'

export const NavPricing: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <circle cx="12" cy="12" r="10" fill="none" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" fill="none" />
      <path d="M12 18V6" fill="none" />
    </svg>
  )
}
